import React from 'react';
import PropTypes from 'prop-types';

import { useContext } from '@hooks';
import { mergeClasses } from '@utils';

import { SelectContext } from './Select';

/**
 * Select.Label component that serves as a label for the parent Select component.
 *
 * @component Select.Label
 * @param {Object} props - The properties for the Select.Label component.
 * @param {React.ReactNode} props.children - The text to be displayed as a label.
 * @param {string} [props.className] - Optional additional CSS classes to apply to the Select.Label.
 * @param {Object} [restProps] - Additional properties to be passed to the Select.Label.
 * @returns {ReactElement} The rendered Select.Label component.
 */
export default function SelectLabel({ children, className, ...restProps }) {
  const { isRequired } = useContext(
    SelectContext,
    'Select.Label must be a child of Select.'
  );

  return (
    <span
      className={mergeClasses(
        'text-xs font-semibold uppercase text-dark-gray',
        {
          "after:ml-0.5 after:text-cinnebar after:content-['*']": isRequired
        },
        className
      )}
      {...restProps}
    >
      {children}
    </span>
  );
}

SelectLabel.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

SelectLabel.defaultProps = {
  className: ''
};
